import { Theme } from '@mui/material/styles';
import { Drawer, useMediaQuery } from '@mui/material';
import {
  ACCOUNT_SETTINGS,
  AI_DRAFT_WORKBENCH,
  BUILDWISE_COMPANIES,
  BUILDWISE_CONFIGURATIONS,
  BUILDWISE_GPT_BOOKMARKS,
  BUILDWISE_GPT_CHAT,
  BUILDWISE_GPT_TEXT,
  BUILDWISE_GPT_TEMPLATES,
  BUILDWISE_USERS,
  // COMAPNY_DASHBOARDS,
  COMPANY_CONFIGURATIONS,
  INTEGRATIONS,
  SUBSCRIPTION_SETTINGS,
  TEMPLATES,
  USERS,
  USER_ACTIVITY_DASHBOARDS,
  USER_GROUPS,
  COMPANY_PROGRESS_CARDS,
  ADMIN_PROGRESS_CARDS,
  COMPANY_SCORECARDS,
  ADMIN_SCORECARDS,
  COMPANY_BUILDWISE_SCORECARDS,
  ADMIN_BUILDWISE_SCORECARDS,
  SUGGESTION_CONTACTS,
  COMPANY_RETROSPECTIVES,
  ADMIN_RETROSPECTIVES,
  POPULAR_POSTS,
  ACCESS_REQUESTS,
  DASHBOARD,
} from 'constants/routes';
import Settings2LineIcon from 'remixicon-react/Settings2LineIcon';
import { AbsoluteContainer, FixedContainer, Sidebar, StickyContainer } from './MainDrawer';
import RenderMenu, { MenuItemType } from './RenderMenu';
import useUserData from 'hooks/useUserData';
import { Helmet } from 'react-helmet';
import { useMemo } from 'react';
import usePromptTemplatesQuery from 'pages/buildwiseAdmin/BuildWiseGPT/hooks/usePromptTemplatesQuery';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

const CompanyAdminDrawer = () => {
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const { pathname } = useLocation();
  const { user, isNovaAdmin, isNovaOrCompanyAdmin } = useUserData();
  const { templates } = usePromptTemplatesQuery({
    shouldFetch: process.env.REACT_APP_ENVIRONMENT !== 'APP' || isNovaAdmin,
  });

  const menu = useMemo(() => {
    const MENU: MenuItemType[] = [
      {
        title: 'Company Admin',
        icon: <Settings2LineIcon />,
        defaultExpanded: pathname.startsWith('/company-admin'),
        children: _.compact([
          {
            title: 'Dashboard',
            url: DASHBOARD,
          },
          {
            title: 'Company Settings',
            url: ACCOUNT_SETTINGS,
          },
          {
            title: 'Subscription Settings',
            url: SUBSCRIPTION_SETTINGS,
          },
          {
            title: 'Integrations',
            url: INTEGRATIONS,
          },
          {
            title: 'Configurations',
            url: COMPANY_CONFIGURATIONS,
            isHidden: !isNovaAdmin,
          },
          {
            title: 'Templates',
            isHidden: !isNovaAdmin,
            defaultExpanded: false,
            children: [
              {
                title: 'Articles',
                url: TEMPLATES,
              },
              {
                title: 'Progress Cards',
                url: COMPANY_PROGRESS_CARDS,
              },
              {
                title: 'Scorecards',
                url: COMPANY_SCORECARDS,
              },
              {
                title: 'BuildWise Scorecards',
                url: COMPANY_BUILDWISE_SCORECARDS,
              },
              {
                title: 'Retrospectives',
                url: COMPANY_RETROSPECTIVES,
              },
            ],
          },
          {
            title: 'User Administration',
            defaultExpanded: false,
            children: [
              {
                title: 'Users',
                url: USERS,
              },
              // {
              //   title: 'User Groups',
              //   url: USER_GROUPS,
              // },
              {
                title: 'Point of Contacts',
                url: SUGGESTION_CONTACTS,
              },
              {
                title: 'Access Requests',
                url: ACCESS_REQUESTS,
              },
            ],
          },
          // {
          //   title: 'Popular Posts',
          //   url: POPULAR_POSTS,
          // },
          // {
          //   title: 'Reports',
          //   defaultExpanded: false,
          //   isHidden: !isNovaAdmin,
          //   children: [
          //     {
          //       title: 'User Activity',
          //       url: USER_ACTIVITY_DASHBOARDS,
          //     },
          //   ],
          // },
          // {
          //   title: 'BuildWise GPT',
          //   defaultExpanded: false,
          //   isHidden:
          //     (process.env.REACT_APP_ENVIRONMENT === 'APP' || isNovaAdmin) &&
          //     process.env.REACT_APP_ENVIRONMENT !== 'LOCAL',
          //   children: [
          //     {
          //       title: 'Text',
          //       url: BUILDWISE_GPT_TEXT,
          //     },
          //     {
          //       title: 'Chat',
          //       url: BUILDWISE_GPT_CHAT,
          //     },
          //     {
          //       title: 'Bookmarks',
          //       url: BUILDWISE_GPT_BOOKMARKS,
          //       badgeContent: user?.gptPromptIds?.length || 0,
          //     },
          //     {
          //       title: 'Templates',
          //       url: BUILDWISE_GPT_TEMPLATES,
          //       badgeContent: templates.length,
          //     },
          //   ],
          // },
        ]),
      },
      {
        title: 'BuildWise Admin',
        icon: <Settings2LineIcon />,
        isHidden: !isNovaAdmin,
        defaultExpanded:
          pathname.startsWith('/buildwise-admin') || pathname.startsWith('/buildwise-gpt'),
        children: _.compact([
          {
            title: 'Companies',
            url: BUILDWISE_COMPANIES,
          },
          {
            title: 'Users',
            url: BUILDWISE_USERS,
          },
          {
            title: 'AI-Drafts Workbench',
            url: AI_DRAFT_WORKBENCH,
          },
          {
            title: 'Configurations',
            url: BUILDWISE_CONFIGURATIONS,
            isHidden: !isNovaAdmin,
          },
          {
            title: 'Templates',
            defaultExpanded: false,
            children: [
              {
                title: 'Progress Cards',
                url: ADMIN_PROGRESS_CARDS,
              },
              {
                title: 'Scorecards',
                url: ADMIN_SCORECARDS,
              },
              {
                title: 'BuildWise Scorecards',
                url: ADMIN_BUILDWISE_SCORECARDS,
              },
              {
                title: 'Retrospectives',
                url: ADMIN_RETROSPECTIVES,
              },
            ],
          },
          {
            title: 'BuildWise GPT',
            defaultExpanded: false,
            isHidden: false,
            children: [
              {
                title: 'Text',
                url: BUILDWISE_GPT_TEXT,
              },
              {
                title: 'Chat',
                url: BUILDWISE_GPT_CHAT,
              },
              {
                title: 'Bookmarks',
                url: BUILDWISE_GPT_BOOKMARKS,
                badgeContent: user?.gptPromptIds?.length || 0,
              },
              {
                title: 'Templates',
                url: BUILDWISE_GPT_TEMPLATES,
                badgeContent: templates.length,
              },
            ],
          },
        ]),
      },
    ];

    return MENU;
  }, [user, isNovaAdmin, process.env, pathname]);

  return (
    <>
      <Helmet>
        <title>{`${process.env.REACT_APP_TITLE} - Admin Console`}</title>
      </Helmet>
      {isMd && (
        <Sidebar
          component="aside"
          sx={(theme) => ({
            width: theme.drawerWidth,
          })}
        >
          <AbsoluteContainer>
            <FixedContainer>
              <StickyContainer>
                <Drawer
                  variant="persistent"
                  open
                  sx={{
                    '& .MuiPaper-root': {
                      position: 'initial',
                      height: `calc(100vh - 100px)`,
                    },
                  }}
                >
                  <RenderMenu menu={menu} />
                </Drawer>
              </StickyContainer>
            </FixedContainer>
          </AbsoluteContainer>
        </Sidebar>
      )}
    </>
  );
};

export default CompanyAdminDrawer;
